import Vue from 'vue'
import Vuex from 'vuex'
import alerts from './alerts'
import login from './login'
import viralmobile from './viralmobile'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {},
  mutations: {},
  actions: {},
  modules: {
    alerts,
    login,
    viralmobile
  }
})
